import { render, staticRenderFns } from "./NewsletterPreferencesSectionModule.vue?vue&type=template&id=f7327ed0&"
import script from "./NewsletterPreferencesSectionModule.vue?vue&type=script&lang=js&"
export * from "./NewsletterPreferencesSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports